import { all } from 'redux-saga/effects'

import orders from './orders'
import analytics from './analytics'
import skills from './skills'
import users from './users'
import cities from './cities'
import auth from './auth'

function * rootSaga () {
  yield all([
    orders(),
    analytics(),
    skills(),
    users(),
    cities(),
    auth(),
  ])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/saga/rootSaga.js